import React from 'react'
import { LocationFeature } from 'services/api/entities/catalog/locationFeatures/types/internal/locationFeatures-models'
import { useKGetList } from 'services/hooks/useKGetList'
import { LocationFeatureCategory } from 'types/form'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'

type Props = {
  type: LocationFeatureCategory
  source: string
}

const LocationFeatureInput: React.FC<Props> = ({ type, source }) => {
  const choices = useKGetList<LocationFeature>('locationfeatures').filter(
    (f) => f.category === type
  )

  return (
    <LocalizedSelectArrayInput
      source={source}
      choices={choices}
      label={`form.fields.${source}`}
      fullWidth
    />
  )
}

export default LocationFeatureInput
